import hasStorage from '@/utils/storage/hasStorage'

export const enableInactivePopup = () => {
    if (hasStorage()) {
        sessionStorage.removeItem('s1InactivityModal')
        if (localStorage.getItem('s1AdminActive') !== 'true') {
            localStorage.removeItem('s1InactivityModal')
        }
    }
}

export const disableInactivePopup = () => {
    if (hasStorage()) {
        sessionStorage.s1InactivityModal = 'disabled'
        localStorage.s1InactivityModal = 'disabled'
    }
}
